
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/[slug]",
      function () {
        return require("private-next-pages/contact-us/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/[slug]"])
      });
    }
  